/**
 * Everything a stat effect or condition needs to answer a question about the hit in flight.
 *
 * The game reaches for a live world here — `event.source`, `event.target`, the player's
 * cooldown map, the time of day. A build planner has none of that, so the context carries the
 * declared substitutes and, importantly, a way to say *"I was asked something I cannot know"*.
 * Every such question ends up in `report`, never silently defaulted.
 */
export function sheetValue(sheet, statId) {
    return sheet.get(statId)?.value ?? 0;
}
export function sheetOf(ctx, side) {
    return side === "Source" ? ctx.source : ctx.target;
}
export function levelOf(ctx, side) {
    return side === "Source" ? ctx.sourceLevel : ctx.targetLevel;
}
//# sourceMappingURL=ctx.js.map